import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';
import { UflaUser } from './ufla-user';

@Injectable({
    providedIn: 'root',
})
export class OauthBffAuthenticationService {
    private httpClient = inject(HttpClient);
    private authenticationService = inject(AuthenticationService);

    public async requestSession(code: string): Promise<boolean> {
        const redirectUri = environment.oauth.redirectUrl;
        const authUrl = environment.API_URL + '/auth/session';

        try {
            await firstValueFrom(this.httpClient.options(authUrl)); // CSRF "Handshake"

            const response = await firstValueFrom(this.httpClient.post<UflaUser>(authUrl, {
                code,
                redirectUri,
            }));

            if (response && response.organisationsId) {
                this.authenticationService.setPrincipal(response as UflaUser);
            }

            return true;
        } catch (error) {
            throw error;
        }
    }
}
